import type { IfOperator } from '../types';
import { normalizeNumericInput } from '../normalizeNumericInput';

const finiteNumber = (value: unknown): number | null => {
  if (typeof value === 'number') return Number.isFinite(value) ? value : null;
  if (typeof value !== 'string' || value.trim() === '') return null;
  const parsed = Number(normalizeNumericInput(value));
  return Number.isFinite(parsed) ? parsed : null;
};

export const compareIfValues = (
  input: unknown,
  operator: IfOperator,
  compareValue: string,
): boolean => {
  const inputNumber = finiteNumber(input);
  const compareNumber = finiteNumber(compareValue);

  if (operator === '=' || operator === '≠') {
    const equal = inputNumber !== null && compareNumber !== null
      ? inputNumber === compareNumber
      : String(input ?? '') === compareValue;
    return operator === '=' ? equal : !equal;
  }

  if (inputNumber === null || compareNumber === null) return false;
  switch (operator) {
    case '<': return inputNumber < compareNumber;
    case '<=': return inputNumber <= compareNumber;
    case '=>': return inputNumber >= compareNumber;
    case '>': return inputNumber > compareNumber;
  }
};
